import styled from 'styled-components';
import { Title } from '@prezi/bento';
const HeaderContainer = styled(Title).withConfig({
  displayName: "ModalHeader__HeaderContainer",
  componentId: "tcmihq-0"
})(["padding:8px 4px 8px 8px;", ""], p => p.hasReducedPadding && 'padding-left: 0; padding-top: 0px;');
export default HeaderContainer;